import { AtomicMark } from '@/components/visuals/AtomicMark';

interface EyebrowProps {
  symbol?: string;
  number?: string;
  label?: string;
  children?: React.ReactNode;
  color?: string;
}

export function Eyebrow({
  symbol,
  number,
  label,
  children,
  color,
}: EyebrowProps) {
  return (
    <div
      className="text-eyebrow"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        color: color || 'var(--ink-muted)',
      }}
    >
      <AtomicMark size={12} tone="var(--accent)" />
      {symbol && number && label ? (
        <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
          <span style={{ color: 'var(--ink-secondary)' }}>{symbol}</span>
          <span style={{ opacity: 0.4 }}>/</span>
          <span style={{ color: 'var(--ink-secondary)' }}>{number}</span>
          <span style={{ opacity: 0.4 }}>/</span>
          <span>{label}</span>
        </span>
      ) : (
        <span>{children}</span>
      )}
    </div>
  );
}
